import { render, staticRenderFns } from "./HistoryAuction.vue?vue&type=template&id=2dc6d917&scoped=true"
import script from "./HistoryAuction.vue?vue&type=script&lang=js"
export * from "./HistoryAuction.vue?vue&type=script&lang=js"
import style0 from "./HistoryAuction.vue?vue&type=style&index=0&id=2dc6d917&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6d917",
  null
  
)

export default component.exports